/**
 * href pattern: origin/pathname?search#hash
 * 1. search value passed previously via paramforwarding script
 * 2. Need to add Hash #orderNow to the main CTA, after the search value to be effective on product page 
 */

const mainCTA = document.querySelector('#mainCTA');

if ($(mainCTA).length) {    
    let mainHref = mainCTA.href; //- get href with search value
    
    //- create new object to assign hash
    let newHrefObj = new URL(mainHref);
    
    //- Assign hash to href Object
    newHrefObj.hash = '#orderNow';
    
    let newHref = newHrefObj.href;
    
    $(this).attr('href', newHref);
}